export const trackPageview = (pathname, gaId) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('config', gaId, {
    page_path: pathname,
    page_location: window.location.href,
    page_title: document.title,
  });
};